export function assetHierarchyQueryKey(query) {
    return (query.assetId ? query.assetId + ':' : '') + query.assetHierarchyId;
}
export var LoadingStateEnum;
(function (LoadingStateEnum) {
    LoadingStateEnum[LoadingStateEnum["NOT_LOADED"] = 0] = "NOT_LOADED";
    LoadingStateEnum[LoadingStateEnum["LOADING"] = 1] = "LOADING";
    LoadingStateEnum[LoadingStateEnum["PAUSED"] = 2] = "PAUSED";
    LoadingStateEnum[LoadingStateEnum["LOADED"] = 3] = "LOADED";
})(LoadingStateEnum || (LoadingStateEnum = {}));
export const HIERARCHY_ROOT_ID = 'HIERARCHY_ROOT_ID';
